import { FilterType } from "src/api/types";
import ProductFilter from "src/components/ProductFilter";
import { CODE, DISCOUNT, PRODUCT, STATUS } from "src/constants/searchParams";

export const filters: FilterType[] = [
  {
    name: STATUS,
    placeholder: "Status",
    type: "select",
    values: ["active", "inactive"],
  },
  {
    name: PRODUCT,
    placeholder: "Product",
    type: "custom",
    component: ProductFilter,
  },
  {
    name: DISCOUNT,
    placeholder: "Discount amount",
    type: "text",
  },
  {
    name: CODE,
    placeholder: "Code name",
    type: "text",
  },
];
